import axiosInstance from '@/services/axiosInstance'

async function getNextInvoicePresupuestoProforma (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    
  } else {
    const req = {
      url: '/api/emisionfacturas/getnextinvoicepresupuestoproforma',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getNextInvoicePresupuestoProforma }
